import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import heroBg from "@/assets/hero-bg.webp";
import { trackContactConversion } from "@/lib/gtag";

export const Hero = () => {
  const { t } = useTranslation();
  const STATS = [
    { value: "100%", label: t("hero.stats.sectors") },
    { value: "5", label: t("hero.stats.platforms") },
    { value: "360°", label: t("hero.stats.execution") },
    { value: "AI-First", label: t("hero.stats.ai") },
  ];

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <img
        src={heroBg}
        alt=""
        aria-hidden
        width={1600}
        height={1126}
        fetchPriority="high"
        decoding="async"
        className="absolute inset-0 h-full w-full object-cover opacity-60"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background/60 via-background/30 to-background" />
      <div className="glass-orbs" aria-hidden />

      <div className="container-x relative z-10 pt-32 pb-24">
        <p className="mb-6 text-xs uppercase tracking-[0.25em] text-muted-foreground animate-fade-up">
          {t("hero.eyebrow")}
        </p>
        <h1 className="font-display text-5xl md:text-7xl lg:text-8xl font-light leading-[0.95] tracking-tight text-foreground max-w-5xl animate-fade-up">
          {t("hero.title1")}<br />{t("hero.title2")}
        </h1>
        <p className="mt-8 max-w-2xl text-base md:text-lg text-muted-foreground font-light animate-fade-up">
          {t("hero.desc")}
        </p>

        <div className="mt-12 flex flex-wrap gap-4 animate-fade-up">
          <Link
            to="/contact"
            onClick={trackContactConversion}
            className="inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors shadow-[0_10px_40px_-10px_hsla(212,100%,50%,0.5)]"
          >
            {t("hero.ctaPrimary")} <span aria-hidden>→</span>
          </Link>
          <Link
            to="/platforms"
            className="inline-flex items-center gap-2 glass-pill rounded-full px-6 py-3 text-sm font-medium text-foreground"
          >
            {t("hero.ctaSecondary")}
          </Link>
        </div>

        <dl className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-4 animate-fade-up">
          {STATS.map((s) => (
            <div key={s.label} className="glass-wow glass-shimmer rounded-xl p-6 transition-all duration-500">
              <dt className="font-display text-3xl md:text-4xl font-light text-foreground">
                {s.value}
              </dt>
              <dd className="mt-2 text-xs uppercase tracking-[0.2em] text-muted-foreground">
                {s.label}
              </dd>
            </div>
          ))}
        </dl>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 scroll-indicator">
        <span className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground">{t("hero.scroll")}</span>
        <div className="h-8 w-px bg-muted-foreground/40" />
      </div>
    </section>
  );
};
